import { render, staticRenderFns } from "./campaign-stream-stats-plate.vue?vue&type=template&id=53c24a96&scoped=true&"
import script from "./campaign-stream-stats-plate.vue?vue&type=script&lang=js&"
export * from "./campaign-stream-stats-plate.vue?vue&type=script&lang=js&"
import style0 from "./campaign-stream-stats-plate.vue?vue&type=style&index=0&id=53c24a96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c24a96",
  null
  
)

export default component.exports